/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'profile-user': {
    width: 22,
    height: 22.601,
    viewBox: '0 0 22 22.601',
    data: '<path pid="0" d="M21.9 22.601H0V22c0-5.3 1.4-6 4.3-7.2 1-.399 2-.8 3.3-1.5v-.6c-.8-.7-1-1.8-1.3-2.8v-.1c-.2-.2-.3-.5-.3-.9-.1-.2-.1-.4-.2-.6v-.1c-.2-.5-.4-1.3 0-1.8.1-.1.1-.1.2-.1-.3-1.9-.5-4.4 2-5.3.2-.5.7-1 2.4-1 2 0 5.1 1 5.7 3.1.301.8.101 2.3 0 3.2.6.5.3 1.5.1 2.1v.1c-.1.2-.1.5-.2.7 0 .3-.1.6-.3.7-.3 1-.601 2.1-1.3 2.8v.8c1.199.7 2.3 1.101 3.199 1.5 3 1.2 4.4 2 4.4 7.101l-.099.5zM1.2 21.4h19.5c-.1-4-1.2-4.4-3.7-5.4-1-.399-2.3-.899-3.7-1.8L13 14v-2l.3-.2c.3-.2.5-.6.7-1.1v.2l.7-4.3c.2-.9.3-2.6.1-3.3-.4-1.4-2.7-2.3-4.6-2.3-.9 0-1.3.3-1.3.3v.4l-.4.1c-2 .6-2.1 2.4-1.7 4.7L7 8.1c0 .1-.1.3 0 .4l.2.3.2.8c.2 1 .4 1.9 1.1 2.4l.2.2V14l-.1.2c-1.5.9-2.7 1.4-3.8 1.8-2.4.9-3.5 1.3-3.6 5.4"/>'
  }
})
